import { isShadowToken } from '@smoothie-framework/ui-core/tokens';
import { isCssWideKeyword } from './css-wide-keywords';
import { containsTokenReferenceSyntax, isBareUtilityIdentifier } from './utility-value-syntax';
export function classifyShadowUtilityValue(rawValue) {
    if (rawValue === undefined || rawValue === null) {
        return { valid: false, reason: 'empty' };
    }
    if (typeof rawValue !== 'string') {
        return { valid: false, reason: 'invalid_type' };
    }
    const normalizedValue = rawValue.trim();
    if (normalizedValue.length === 0) {
        return { valid: false, reason: 'empty' };
    }
    if (containsTokenReferenceSyntax(normalizedValue)) {
        return { valid: false, reason: 'token_reference', normalizedValue };
    }
    if (isShadowToken(normalizedValue)) {
        return { valid: true, kind: 'token', normalizedValue };
    }
    if (isBareUtilityIdentifier(normalizedValue)) {
        if (!isCssWideKeyword(normalizedValue)) {
            return { valid: false, reason: 'unsupported_bare_identifier', normalizedValue };
        }
        return { valid: true, kind: 'keyword', normalizedValue };
    }
    return { valid: true, kind: 'arbitrary', normalizedValue };
}
//# sourceMappingURL=shadow-values.js.map